<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Sinkronisasi Data Penduduk</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Kependudukan</a>
            </div>
            <div class="breadcrumb-item">
              Sinkronisasi Data
            </div>
          </div>
        </div>

				
        <div class="section-body">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div v-if="aksiSync === 0">
                <SinkronisasiTable 
                  :riwayat-import="riwayatImport"
                  :ready-import="readyImport"
                  :loading-riwayat="loadingRiwayat"
                  @setAksiSync="setAksiSync"
                  @detailRiwayat="detailRiwayat"
                  @sinkronisasi="sinkronisasi"
                />
              </div>
              <div v-if="aksiSync === 1">
                <SinkronisasiUpload
                  @setLoaderSinkronisasi="setLoaderSinkronisasi"
                  @setAksiSync="setAksiSync"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <SinkronisasiModalDetail
      :detail-riwayat-import="detailRiwayatImport"
    />

    <div
      class="overlay-page-loader"
      v-if="isSinkronisasi"
    >
      <img
        :src="require('./../../assets/img/icon/excel.png')"
        width="100"
      ><br>
      <p class="h6 mt-3 text-dark">
        Harap tunggu. Proses sinkronisasi sedang berlangsung.
      </p>
      <div class="spinner" />
    </div>
		
    <SinkronisasiNikDouble />
  </LayoutAdmin>
</template>


<script>
import swal from 'sweetalert'
import LayoutAdmin from '../layouts/Admin.vue'
import SinkronisasiModalDetail from '../../components/kependudukan/sinkronisasi/SinkronisasiModalDetail.vue'
import SinkronisasiTable from '../../components/kependudukan/sinkronisasi/SinkronisasiTable.vue'
import SinkronisasiUpload from '../../components/kependudukan/sinkronisasi/SinkronisasiUpload.vue'
import SinkronisasiNikDouble from '../../components/kependudukan/sinkronisasi/SinkronisasiNikDouble.vue'

export default {
  data() {
    return {
      aksiSync: 0, // 0=riwayat, 1=mulai sync
      riwayatImport: [],
      readyImport: null,
      isSinkronisasi: false,
      detailRiwayatImport: {},
      loadingRiwayat: false,
    }
  },
  components: {
    LayoutAdmin, SinkronisasiModalDetail, SinkronisasiTable, SinkronisasiUpload, SinkronisasiNikDouble
  },
  methods: {
    setAksiSync(val) {
      this.aksiSync = val
    },
    setLoaderSinkronisasi(val) {
      this.isSinkronisasi = val
    },
    loadRiwayat() {
      this.loadingRiwayat = true
      this.$store.dispatch('fetchRiwayatImportPenduduk').then(res => {
        if (res.data.status) {
          let rImport = []
          let readyImport = null

          res.data.data.forEach(e => {
            if (e.status === 0) {
              readyImport = e
            } else {
              rImport.push(e)
            }
          })
          this.riwayatImport = rImport
          this.readyImport = readyImport
        }
        this.loadingRiwayat = false
      })
    },
    sinkronisasi(r) {
      let button = document.querySelector(`.btn-sinkronkan[data-id="${r.id_riwayat_sync_penduduk}"]`)
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-sync"></i> Sinkronisasi data....'
      swal({
        title: "Konfirmasi",
        text: "Yakin ingin sinkronisasi data? Harap cek detail data perubahan penduduk sebelum sinkronisasi",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, sinkronisasi sekarang",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          let formData = new FormData
          formData.append('id_riwayat_sync_penduduk', r.id_riwayat_sync_penduduk)
          this.$store.dispatch('sinkronisasiPenduduk', r.id_riwayat_sync_penduduk).then(res => {
            this.isSinkronisasi = false
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              this.loadRiwayat()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
          }).catch(err => {
            this.isSinkronisasi = false
            // console.log(err)
            switch (err.response.status) {
              case 500:
                this.$router.push({ path: '/500' })
                break;

              case 400:
                swal({
                  title: "Gagal",
                  text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;

              default:
                swal({
                  title: "Gagal",
                  text: err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
          })
        } else {

          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
        }
      })
    },
    detailRiwayat(r) {
      this.$bvModal.show('modal-detail-sync')
      this.detailRiwayatImport = r
    }
  },
  created() {
    this.loadRiwayat()
  }
}
</script>